export default __webpack_public_path__ + "static/media/people.cda12740.svg";